import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { DashboardMetrics, ActivityFeedItem } from '@/types';

interface DashboardState {
  metrics: DashboardMetrics | null;
  activityFeed: ActivityFeedItem[];
  timeRange: '24h' | '7d' | '30d' | '90d';
  loading: boolean;
  error: string | null;
}

const initialState: DashboardState = {
  metrics: null,
  activityFeed: [],
  timeRange: '24h',
  loading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setMetrics: (state, action: PayloadAction<DashboardMetrics>) => {
      state.metrics = action.payload;
    },
    setActivityFeed: (state, action: PayloadAction<ActivityFeedItem[]>) => {
      state.activityFeed = action.payload;
    },
    addActivityItem: (state, action: PayloadAction<ActivityFeedItem>) => {
      state.activityFeed.unshift(action.payload);
      // Keep only last 100 items
      if (state.activityFeed.length > 100) {
        state.activityFeed = state.activityFeed.slice(0, 100);
      }
    },
    setTimeRange: (state, action: PayloadAction<'24h' | '7d' | '30d' | '90d'>) => {
      state.timeRange = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const {
  setMetrics,
  setActivityFeed,
  addActivityItem,
  setTimeRange,
  setLoading,
  setError,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;